import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import axios from "axios";
import { toast, type Id } from "react-toastify";
import { AD_STATES } from "../../../components/core/blocks/AdPlan/constants";

export function useBulkUpdateAdState() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (vars: { ads: { id: number; name: string }[]; state: "active" | "paused" }) => {
      const stateId = vars.state === "active" ? AD_STATES.ACTIVE.value : AD_STATES.PAUSE.value;
      let toastId: Id | null = null;
      for (let i = 0; i < vars.ads.length; i++) {
        const ad = vars.ads[i]!;
        const progress = (i + 1) / vars.ads.length;
        try {
          await apiClient.setAdState({
            id: ad.id,
            state: stateId as 0 | 1,
          });
        } catch (e) {
          if (
            axios.isAxiosError(e) &&
            !!e.response?.data &&
            "Failed to Pause Campaigns" in e.response.data &&
            e.response.data["Failed to Pause Campaigns"] === "Can't pause composite ads"
          ) {
            // Skip composite ads
          } else {
            toast(`Failed to update Media Plan ${ad.name}`, { type: "error" });
          }
        } finally {
          if (!toastId) {
            toastId = toast(`Updating Media Plan${vars.ads.length > 1 ? "s" : ""}`, { progress, type: "info" });
          } else {
            toast.update(toastId, { progress });
          }
        }
      }
      if (toastId) {
        toast.update(toastId, {
          render: `Media Plan${vars.ads.length > 1 ? "s" : ""} Updated`,
          type: "success",
          progress: undefined,
        });
      }
    },
    onSuccess: () => {
      // TODO: shouldn't invalidate _all_ queries
      void queryClient.invalidateQueries();
    },
  });
}
